module.exports = __webpack_public_path__ + "static/media/NotebookPaper.e0ec7907.png";